<template>
  <div class="batch-upload-candidate" v-if="show" :class="{ uploading }">
    <div class="container-line file-selector-container">
      <div class="container-content">
        <div class="upload-dragger" @dragover.prevent="handleDragOver" @drop.prevent="handleDrop">
          <div class="upload-icon">
            <i class="iconfont iconupload"></i>
          </div>
          <div class="drop-tip">{{ $t(`${i18nPrefix}.message.dropTip`) }}</div>
          <div class="or-tip">{{ $t(`${i18nPrefix}.message.or`) }}</div>
          <div class="browser-file">
            <label :for="uploading || 'browserFiles'" class="browser-file-label">{{ $t(`${i18nPrefix}.label.browserFiles`) }}</label>
            <input
              id="browserFiles"
              ref="browserFilesInput"
              type="file"
              multiple="multiple"
              class="browser-file-input"
              :accept="inputAcceptFileType"
              @change="handleInputFilesChange"
            />
          </div>
          <div class="upload-tip">
            <div v-for="(item, index) in $t(`${i18nPrefix}.message.uploadTip`)" class="tip-block" :key="index">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-line file-list-container" v-show="!uploading && fileList.length > 0">
      <div class="container-title">{{ $t(`${i18nPrefix}.containerTitle.selectedFiles`) }}</div>
      <div class="container-content">
        <div class="file-list">
          <template v-if="fileList.length > 0">
            <div v-for="(file, index) in fileList" class="file" :key="index">
              <div class="file-icon"></div>
              <div class="file-name" >{{ file.name }}</div>
              <div class="remove-btn" @click="handleDeleteFile">
                <i class="el-icon-close"></i>
              </div>
            </div>
          </template>
          <div v-else class="empty-list">{{ $t(`${i18nPrefix}.message.noSelectedFile`) }}</div>
        </div>
        <div v-if="fileList.length > 0" class="upload-btn-container adapt-wrapper">
          <el-button class="upload-btn" @click="handUploadBtnClick">{{ $t(`${i18nPrefix}.btn.startUpload`) }}</el-button>
        </div>
      </div>
    </div>
    <div class="container-line upload-task-container" v-show="uploading">
      <div class="container-title">{{ $t(`${i18nPrefix}.containerTitle.uploadStatus`) }}</div>
      <div class="container-content">
        <div class="upload-task-list">
          <template v-if="uploadTaskList.length > 0">
            <div
              v-for="(uploadTask, index) in uploadTaskList"
              class="upload-task"
              :key="index"
            >
              <div class="file-icon"></div>
              <div class="file-name" >{{ uploadTask.file.name }}</div>
              <div class="upload-progress" :style="{ width: `${uploadTask.percentage}%` }"></div>
            </div>
          </template>
          <div v-else class="empty-list">{{ $t(`${i18nPrefix}.message.noUploadingFile`) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

const MAX_FILE_COUNT = 500
const MAX_FILE_SIZE = 100 * 1024 * 1024 // 100MB

export default {
  data () {
    return {
      i18nPrefix: 'admin.application.batchUpload',
      acceptFileTypes: [
        'text/html',
        'application/pdf',
        'application/msword', // .doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/zip',
        'application/x-zip-compressed',
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/bmp'
      ],
      fileList: []
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    uploadTaskList: {
      type: Array,
      default: () => []
    },
    uploading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputAcceptFileType () {
      return this.acceptFileTypes.join(',')
    }
  },
  created () {

  },
  methods: {
    ...mapActions('application', ['uploadTaskFile', 'getUploadToken']),
    addSelectFile (files) {
      if (!files || this.uploading) {
        return
      }
      const fileList = _.filter(files, file => {
        return this.acceptFileTypes.includes(file.type) && file.size < MAX_FILE_SIZE
      })
      if (fileList.length + this.fileList.length > MAX_FILE_COUNT) {
        this.$message.error(this.$t(`${this.i18nPrefix}.message.fileCountLimit`, { count: MAX_FILE_COUNT }))
        return
      }
      this.fileList.push(...fileList)
    },
    handleDragOver ($event) {

    },
    handleDrop ($event) {
      this.addSelectFile($event.dataTransfer?.files)
    },
    handleInputFilesChange ($event) {
      this.addSelectFile($event.target?.files)
    },
    handleDeleteFile (index) {
      this.fileList.splice(index, 1)
    },
    handleClearFileList () {
      this.fileList = []
    },
    clearBrowserFilesInputValue () {
      this.$refs.browserFilesInput.value = null
    },
    async handUploadBtnClick () {
      this.$emit('uploadFile', this.fileList, this.clearBrowserFilesInputValue, this.handleClearFileList)
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-upload-candidate {
  $main-color: #6c6c6c;
  margin-top: 40px;

  .file-selector-container {
    margin-bottom: 16px;
  }

  &.uploading {
    .upload-dragger {
      cursor: not-allowed;

      * {
        cursor: not-allowed;
      }

      .browser-file {
        .browser-file-label {
          cursor: not-allowed;
        }
      }
    }
  }

  .container-line {
    // margin-bottom: 15px;

    .container-title {
      // display: flex;
      // justify-content: space-between;
      margin-bottom: 4px;
      // padding-bottom: 10px;
      // border-bottom: 1px solid #dcdfe6;
      font-size: 16px;
      font-weight: 400;
      color: #303133;
    }
  }

  .upload-dragger {
    width: 500px;
    margin: auto;
    padding: 20px;
    border: 1px dashed $main-color;
    text-align: center;
    color: $main-color;

    .upload-icon {
      i {
        font-size: 120px;
      }
    }

    .drop-tip {
      margin-top: 15px;
      font-size: 22px;
    }

    .or-tip {
      margin-top: 10px;
      font-size: 18px;
    }

    .browser-file {
      margin-top: 10px;
      font-size: 18px;

      .browser-file-label {
        display: inline-block;
        padding: 5px 25px;
        color: #ffffff;
        background-color: $main-color;
        cursor: pointer;
      }

      &-input {
        display: none;
      }
    }

    .upload-tip {
      margin-top: 15px;
      font-size: 14px;
    }
  }

  .file-list-container {
    width: 500px;
    margin: auto;
    .file-list {
      border-bottom: 1px solid #E4E7ED;
      // padding: 0 15px;

      .file {
        display: flex;
        padding: 12px 0;
        align-items: center;
        cursor: pointer;

        &:not(:last-child) {
          border-bottom: 1px solid #dcdcdc;
        }

        &:hover {
          .remove-btn {
            transform: rotateZ(180deg);
          }
        }

        .file-name {
          flex: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 400;
        }

        .remove-btn {
          margin-left: auto;
          margin-right: 0;
          line-height: 1;
          font-size: 16px;
          transition: transform .3s;
        }
      }

      .empty-list {
        color: $main-color;
        text-align: center;
      }
    }

    .upload-btn-container {
      margin-top: 60px;
      text-align: right;

      .upload-btn {
        padding: 9px 28px;
        background-color: #0096cc;
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 500;
      }
    }
  }

  .upload-task-container {
    width: 500px;
    margin: auto;
    .container-title {
      font-size: 16px;
      font-weight: 400;
      color: #303133;
    }

    .upload-task-list {
      .upload-task {
        height: 35px;
        margin-bottom: 10px;
        line-height: 35px;
        background: #fff;
        position: relative;

        .upload-progress {
          height: 100%;
          transition: width .3s linear;
          background-color: rgba($color: #daecfe, $alpha: 0.5);
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      .empty-list {
        color: $main-color;
        text-align: center;
      }
    }
  }
}
</style>
<style lang="scss">
.tips-content {
  width: 500px;
}
</style>
